module.exports = __webpack_public_path__ + "static/media/addProduct.d48de856.png";